import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { AdminPage } from '../../../components/design-system/admin';
import { Invitations } from '../../../modules/superadmin/users/components/invitations.component';

/** Every invitation and what became of it; opened from the Users page. */
export const InvitationsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <AdminPage
            title={t('ADMIN_USERS.INVITATIONS.TITLE')}
            description={t('ADMIN_USERS.INVITATIONS.DESCRIPTION')}
            parents={[{ label: t('ADMIN_SHELL.NAV.USERS'), href: '/users' }]}
            actions={
                <Button onClick={() => navigate('/users/new')}>
                    <Plus />
                    {t('ADMIN_USERS.ADD')}
                </Button>
            }
        >
            <Invitations showHeader={false} />
        </AdminPage>
    );
};
